const orders = {
    title: 'Your Orders',
    errorLoading: 'Error loading orders',
    noOrders: 'No orders found',
    noOrdersMessage: 'You have not yet placed any product orders',
    orderId: 'Order ID',
    orderedOn: 'Ordered on',
    quantity: 'Quantity',
    each: 'each',
    total: 'Total',
    orderTimeline: 'Order Timeline',
    paidOn: 'Paid on',
    shippedOn: 'Shipped on',
    deliveredOn: 'Delivered on',
    cancelledOn: 'Cancelled on',
    statusPending: 'Pending',
    statusPaid: 'Paid',
    statusShipped: 'Shipped',
    statusDelivered: 'Delivered',
    statusCancelled: 'Cancelled'
};

export default orders;
